import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { LgvLoanApplicationService } from '../../../../core/services/lgv-loan-application.service';
import { BehaviorSubject, take } from 'rxjs';
import { LoanAppPageService } from '../../../../core/services/page-services/loan-app-page.service';
import { LgvUserService } from '../../../../core/core.module';
import { LgvAuthMgrService } from '../../../../core/services/lgv-auth-mgr.service';
import { MatDialog } from '@angular/material/dialog';
import { StatusDetailDialogComponent } from '../../dialogs/status-detail-dialog/status-detail-dialog.component';

@Component({
    selector: 'lgv-status-tracker',
    templateUrl: './status-tracker.component.html',
    styleUrls: ['./status-tracker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default
})
export class StatusTrackerComponent implements OnInit {
    statuses = null;
    currentStatus$ = new BehaviorSubject('');
    nextStatus$ = new BehaviorSubject('');
    statusProgress$ = new BehaviorSubject(0);
    loanApp: any;

    constructor(
        private loanAppPageSvc: LoanAppPageService,
        public lgvAuthMgr: LgvAuthMgrService,
        private dialog: MatDialog
    ) {}

    ngOnInit() {
        this.loanAppPageSvc.selectedLoanApplication$
            .pipe(take(1))
            .subscribe(cla => {
                this.loanApp = cla;
                this.statuses =
                    cla?.loanTimeline?.statusTracker?.summaryLoanStatuses;
                this.getCurrentStatusProgress(cla?.loanTimeline?.statusTracker);
            });
    }

    getCurrentStatusProgress(statusTracker) {
        const statuses = statusTracker.summaryLoanStatuses;
        const inProgressIndex = statuses?.findIndex(
            status => status?.isInProgress
        );
        const currentStatus = statusTracker?.lastCompletedStep;
        const nextStatus = statusTracker?.currentStepLabel;
        const statusProgress =
            inProgressIndex != 0
                ? (inProgressIndex / statuses?.length) * 100
                : 10;

        this.currentStatus$.next(currentStatus);
        this.nextStatus$.next(nextStatus);
        this.statusProgress$.next(statusProgress);
    }

    openStatusDetailsModal() {
        this.dialog.open(StatusDetailDialogComponent, {
            data: {
                loanNumber: this.loanApp?.loanInfo?.loanNumber,
                loanStatuses: this.loanApp?.loanTimeline?.statusTracker
                    ?.allLoanStatuses,
                updatedTime: this.loanApp?.updatedTimestampUtc
            }
        });
    }
}
